<template>
  <div class="container mt-5">
    <router-link class="float-right" to="/groups">
      <i class="fas fa-chevron-left"></i> Regresar
    </router-link>

    <h2 class="text-light">
      <i class="fas fa-users"></i> Modificar Grupo
    </h2>
    <form @submit.prevent="post()">
      <div class="col-md-4">
        <strong>Nombre:</strong>
        <input v-model="group.name" type="text" class="form-control mb-3" required />        
      </div>

      <h2 class="text-light">Horarios</h2>
      <hr>
      <div class="row">
        <div class="col-md-4">
          <div class="m-4 text-light">
            <h4>Lunes</h4>
            <div class="row">
              <b-form-checkbox v-model="hasSchedule.mondayAm" switch size="lg" class="col-4">AM</b-form-checkbox>
              <input type="time" v-model="schedules.mondayAm" :disabled="!hasSchedule.mondayAm" class="form-control col-4" />
            </div>
            <div class="row mt-2">
              <b-form-checkbox v-model="hasSchedule.mondayPm" switch size="lg" class="col-4">PM</b-form-checkbox>
              <input type="time" v-model="schedules.mondayPm" :disabled="!hasSchedule.mondayPm" class="form-control col-4" />
            </div>

            <h4 class="mt-4">Martes</h4>
            <div class="row">
              <b-form-checkbox v-model="hasSchedule.tuesdayAm" switch size="lg" class="col-4">AM</b-form-checkbox>
              <input type="time" v-model="schedules.tuesdayAm" :disabled="!hasSchedule.tuesdayAm" class="form-control col-4" />
            </div>
            <div class="row mt-2">
              <b-form-checkbox v-model="hasSchedule.tuesdayPm" switch size="lg" class="col-4">PM</b-form-checkbox>
              <input type="time" v-model="schedules.tuesdayPm" :disabled="!hasSchedule.tuesdayPm" class="form-control col-4" />
            </div>

            <div class="row mt-5">
              <button class="btn btn-dark btn-lg" type="submit">
                Guardar
                <i class="fa fa-save"></i>
              </button>
              <router-link class="btn btn-dark btn-lg ml-3" to="/groups">
                Cancelar
                <i class="far fa-times-circle"></i>
              </router-link>
            </div>
          </div>
        </div>

        <div class="col-md-4">
          <div class="m-4 text-light">
            <h4>Miércoles</h4>
            <div class="row">
              <b-form-checkbox v-model="hasSchedule.wednesdayAm" switch size="lg" class="col-4">AM</b-form-checkbox>
              <input type="time" v-model="schedules.wednesdayAm" :disabled="!hasSchedule.wednesdayAm" class="form-control col-4" />
            </div>
            <div class="row mt-2">
              <b-form-checkbox v-model="hasSchedule.wednesdayPm" switch size="lg" class="col-4">PM</b-form-checkbox>
              <input type="time" v-model="schedules.wednesdayPm" :disabled="!hasSchedule.wednesdayPm" class="form-control col-4" />
            </div>

            <h4 class="mt-4">Jueves</h4>
            <div class="row">
              <b-form-checkbox v-model="hasSchedule.thursdayAm" switch size="lg" class="col-4">AM</b-form-checkbox>
              <input type="time" v-model="schedules.thursdayAm" :disabled="!hasSchedule.thursdayAm" class="form-control col-4" />
            </div>
            <div class="row mt-2">
              <b-form-checkbox v-model="hasSchedule.thursdayPm" switch size="lg" class="col-4">PM</b-form-checkbox>
              <input type="time" v-model="schedules.thursdayPm" :disabled="!hasSchedule.thursdayPm" class="form-control col-4" />
            </div>
          </div>
        </div>
        
        <div class="col-md-4">
          <div class="m-4 text-light">
            <h4>Viernes</h4>
            <div class="row">
              <b-form-checkbox v-model="hasSchedule.fridayAm" switch size="lg" class="col-4">AM</b-form-checkbox>
              <input type="time" v-model="schedules.fridayAm" :disabled="!hasSchedule.fridayAm" class="form-control col-4" />
            </div>
            <div class="row mt-2">
              <b-form-checkbox v-model="hasSchedule.fridayPm" switch size="lg" class="col-4">PM</b-form-checkbox>
              <input type="time" v-model="schedules.fridayPm" :disabled="!hasSchedule.fridayPm" class="form-control col-4" />
            </div>

            <h4 class="mt-4">Sábado</h4>
            <div class="row">
              <b-form-checkbox v-model="hasSchedule.saturdayAm" switch size="lg" class="col-4">AM</b-form-checkbox>
              <input type="time" v-model="schedules.saturdayAm" :disabled="!hasSchedule.saturdayAm" class="form-control col-4" />
            </div>
            <div class="row mt-2">
              <b-form-checkbox v-model="hasSchedule.saturdayPm" switch size="lg" class="col-4">PM</b-form-checkbox>
              <input type="time" v-model="schedules.saturdayPm" :disabled="!hasSchedule.saturdayPm" class="form-control col-4" />
            </div>
            
            <h4 class="mt-4">Domingo</h4>
            <div class="row">
              <b-form-checkbox v-model="hasSchedule.sundayAm" switch size="lg" class="col-4">AM</b-form-checkbox>
              <input type="time" v-model="schedules.sundayAm" :disabled="!hasSchedule.sundayAm" class="form-control col-4" />
            </div>
            <div class="row mt-2">
              <b-form-checkbox v-model="hasSchedule.sundayPm" switch size="lg" class="col-4">PM</b-form-checkbox>
              <input type="time" v-model="schedules.sundayPm" :disabled="!hasSchedule.sundayPm" class="form-control col-4" />
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  props: ["id"],
  data() {
    return {
      url: this.$store.state.url,
      schoolId: this.$store.state.schoolId,
      group: {},

      schedules:{},
      hasSchedule: {
        mondayAm: false,
        mondayPm: false,
        tuesdayAm: false,
        tuesdayPm: false,
        wednesdayAm: false,
        wednesdayPm: false,
        thursdayAm: false,
        thursdayPm: false,
        fridayAm: false,
        fridayPm: false,
        saturdayAm: false,
        saturdayPm: false,
        sundayAm: false,
        sundayPm: false
      },
    };
  },
  mounted(){
      this.getData()
  },
  methods: {
    async getData() {
      let req = await fetch(this.url + "group/" + this.id);
      let result = await req.json();
      this.group = result.group
      this.schedules = result.schedule

      if (this.schedules.mondayAm)
        this.hasSchedule.mondayAm=true      
      if (this.schedules.mondayPm)
        this.hasSchedule.mondayPm=true
      
      if (this.schedules.tuesdayAm)
        this.hasSchedule.tuesdayAm=true      
      if (this.schedules.tuesdayPm)
        this.hasSchedule.tuesdayPm=true

      if (this.schedules.wednesdayAm)
        this.hasSchedule.wednesdayAm=true      
      if (this.schedules.wednesdayPm)
        this.hasSchedule.wednesdayPm=true
      
      if (this.schedules.thursdayAm)
        this.hasSchedule.thursdayAm=true      
      if (this.schedules.thursdayPm)
        this.hasSchedule.thursdayPm=true

      if (this.schedules.fridayAm)
        this.hasSchedule.fridayAm=true      
      if (this.schedules.fridayPm)
        this.hasSchedule.fridayPm=true

      if (this.schedules.saturdayAm)
        this.hasSchedule.saturdayAm=true      
      if (this.schedules.saturdayPm)
        this.hasSchedule.saturdayPm=true
      
      if (this.schedules.sundayAm)
        this.hasSchedule.sundayAm=true      
      if (this.schedules.sundayPm)
        this.hasSchedule.sundayPm=true
    },
    async post() {
      try {
        this.group.schoolId = this.schoolId;
        let schedule = this.schedules

        if (!this.hasSchedule.mondayAm)
          schedule.mondayAm = null
        if (!this.hasSchedule.mondayPm)
          schedule.mondayPm = null

        if (!this.hasSchedule.tuesdayAm)
          schedule.tuesdayAm = null
        if (!this.hasSchedule.tuesdayPm)
          schedule.tuesdayPm = null
        
        if (!this.hasSchedule.wednesdayAm)
          schedule.wednesdayAm = null
        if (!this.hasSchedule.wednesdayPm)
          schedule.wednesdayPm = null

        if (!this.hasSchedule.thursdayAm)
          schedule.thursdayAm = null
        if (!this.hasSchedule.thursdayPm)
          schedule.thursdayPm = null
        
        if (!this.hasSchedule.fridayAm)
          schedule.fridayAm = null
        if (!this.hasSchedule.fridayPm)
          schedule.fridayPm = null
        
        if (!this.hasSchedule.saturdayAm)
          schedule.saturdayAm = null
        if (!this.hasSchedule.saturdayPm)
          schedule.saturdayPm = null

        if (!this.hasSchedule.sundayAm)
          schedule.sundayAm = null
        if (!this.hasSchedule.sundayPm)
          schedule.sundayPm = null

        let data = {
          method: "put",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({group: this.group, schedule:schedule})
        };
        let req = await fetch(this.url + "group/"+ this.id, data);
        if (req.ok) {
          this.$alert("Dato ingresado correctamente", "Ok", "success").then(
            () => this.$router.push("/groups")
          );
        }
      } catch (error) {
        this.$alert(error, "Ocurrió un error", "error");
      }
    }
  }
};
</script>

<style>
</style>